import { CheckSvg } from '../svg/check-svg'
import { Lang } from '../../translations/lang'

export const OkIcon = () => (
  <span className="inline-flex flex-col justify-between items-center gap-[4px]">
    <CheckSvg />
    <span className="text-xs font-bold text-[#4CAF50]">{Lang.ok}</span>
  </span>
)
